import React, { ReactNode, useMemo, useReducer } from 'react';

import { initialState, UserContext, UserContextType } from './context';
import { reducer } from './reducer';

/**
 * useUserProvider
 */
export const useUserProvider = (): UserContextType => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { user, userFlags, segmentIdentify } = state;

  const provider = useMemo<UserContextType>(
    () => ({
      user,
      userFlags,
      setUser: (data: UserContextType['user']) => {
        dispatch({
          type: 'SET_USER',
          payload: data,
        });
      },
      resetUser: () => {
        dispatch({
          type: 'RESET_USER',
        });
      },
      segmentIdentify,
      segmentIdentifyWasTriggered: () => {
        dispatch({
          type: 'TRIGGER_SEGMENT',
        });
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state],
  );

  return provider;
};

/**
 * UserProvider
 */
export const UserProvider = ({ children }: UserProviderProps) => {
  const userProvider = useUserProvider();

  return (
    <UserContext.Provider value={userProvider}>
      {typeof children === 'function' ? children(userProvider) : children}
    </UserContext.Provider>
  );
};

interface UserProviderProps {
  children: ReactNode | ((context: UserContextType) => ReactNode);
}
